export default function Browser(config = {}) {
  return {
    NAMESPACE: 'google-gtag',
    config,
    initialize,
    page: ({ config: { id }, payload: { properties, userId } }) => {
      gtag('config', id, {
        user_id: userId,
      })
    },
    track: ({ payload: { event, properties } }) => {
      gtag('event', event)
    },
    identify: ({ payload: { userId }, config: { id } }) => {
      gtag('config', id, {
        user_id: userId,
      })
    },
    loaded: () => {
      return Array.isArray(window.dataLayer)
    },
  }
}

function gtag(...args: any[]) {
  window.dataLayer.push(arguments)
}

export function initialize({ config: { id } }) {
  const d = document
  const s = d.createElement('script')

  s.type = 'text/javascript'
  s.async = true
  s.src = 'https://www.googletagmanager.com/gtag/js?id=' + id

  const x = d.getElementsByTagName('script')[0]
  x.parentNode.insertBefore(s, x)

  window.dataLayer = window.dataLayer || []

  gtag('js', new Date())
}
